module.exports = __webpack_public_path__ + "static/media/tommy4.d47249f8.svg";